// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38KpA","delete":"styles_delete__33Su8","update":"styles_update__1QZ68","add":"styles_add__2FKLM"};